<app-permission-set-wizard-copy></app-permission-set-wizard-copy>
<kpd-side-panel [facade]="permissionSetFacade" [entityName]="'Permission set' | translate" class="roles__sidepanel">
  <ng-template kpdTemplate="actionbar" let-selection let-loading="loading" let-deleted="deleted">
    <kpd-action icon="import" (action)="import()" [title]="'Import templates' | translate"></kpd-action>
    <kpd-action-create
      *kpdPermission="Permissions.PermissionsetCreate"
      (action)="onAdd()"
      [title]="'Add permission set' | translate"
    ></kpd-action-create>
    <ng-container *ngIf="selection.length !== 0 && !deleted">
      <div *ngIf="selection.length === 1">
        <kpd-action
          *kpdPermission="Permissions.PermissionsetCopy"
          icon="copy"
          (action)="onCopy(selection[0])"
          [title]="'Copy permission set' | translate"
        ></kpd-action>
      </div>
      <kpd-action-consult-overview (action)="onView(selection[0])" [disable]="loading"></kpd-action-consult-overview>
      <kpd-action-edit-toggle
        *kpdPermission="Permissions.PermissionsetUpdate"
        (action)="onEdit(selection[0])"
        [disable]="loading"
        [readMode]="false"
      ></kpd-action-edit-toggle>
      <kpd-action-delete
        *kpdPermission="Permissions.PermissionsetDelete"
        (action)="onDelete(selection)"
        [disable]="loading"
      ></kpd-action-delete>
    </ng-container>
  </ng-template>

  <ng-template kpdTemplate="singleItem" let-item>
    <h3 translate>General</h3>
    <div class="flex-row flex-wrap">
      <div class="flex-column">
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Application</label>
          <label class="value">{{ item.application | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Permission set</label>
          <label class="value">{{ item.name | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Type</label>
          <label class="value tags">
            <span
              class="state-tag"
              [ngClass]="{ 'state-tag--disabled': item.type !== 'both' && item.type !== 'assign' }"
              >{{ 'Assign' | translate }}</span
            >
            <span
              class="state-tag"
              [ngClass]="{ 'state-tag--disabled': item.type !== 'both' && item.type !== 'use' }"
              >{{ 'Use' | translate }}</span
            >
          </label>
        </div>
      </div>
    </div>
    <h3 translate>Translations</h3>
    <div class="flex-row flex-wrap">
      <div class="flex-column">
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Dutch</label>
          <label class="value">{{ item.description?.dutch | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>English</label>
          <label class="value">{{ item.description?.english | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>French</label>
          <label class="value">{{ item.description?.french | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>German</label>
          <label class="value">{{ item.description?.german | kpdDefault }}</label>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template kpdTemplate="multiItem" let-item>
    <div class="card-small">
      <label class="card__header">
        <span class="card__multival flex-row">
          <b>{{ item.name }}</b
          >&nbsp;-&nbsp;{{ item.application }}
        </span>
      </label>
    </div>
  </ng-template>
  <ng-template kpdTemplate="tiles" let-item>
    <div>
      <kpd-tile
        icon="unlock"
        [title]="'Permissions' | translate"
        [value]="item.permissions ? item.permissions.length : 0"
        (click)="navigateToPermissions(item.key)"
      ></kpd-tile>
    </div>
  </ng-template>
  <kpd-side-panel> </kpd-side-panel
></kpd-side-panel>
